import type { GraphEdge, GraphNode } from './nodeDefs.js';

/**
 * Returns the data sources that can reach a query node through its current
 * graph connections. A disconnected node deliberately has no schema.
 */
export function queryNodeSourceIds(
  nodes: readonly GraphNode[],
  edges: readonly GraphEdge[],
  nodeId: string,
): string[] {
  const nodesById = new Map(nodes.map(node => [node.id, node]));
  const incoming = new Map<string, string[]>();
  for (const edge of edges) {
    const sources = incoming.get(edge.toNode) ?? [];
    sources.push(edge.fromNode);
    incoming.set(edge.toNode, sources);
  }

  const sourceIds = new Set<string>();
  const visited = new Set<string>();
  const pending = [nodeId];
  while (pending.length) {
    const currentId = pending.pop()!;
    if (visited.has(currentId)) continue;
    visited.add(currentId);
    const node = nodesById.get(currentId);
    if (!node) continue;
    if (node.type === 'Source') {
      const sourceId = String(node.data.source ?? '');
      if (sourceId) sourceIds.add(sourceId);
      continue;
    }
    pending.push(...(incoming.get(currentId) ?? []));
  }
  return [...sourceIds].sort();
}
